/**
 * string -> string
 * capitalizeFirstLetter('hELLO') // "HELLO"
 */ export default function capitalizeFirstLetter(x) {
    return x.charAt(0).toUpperCase() + x.slice(1);
}
